// third-party
import { combineReducers } from 'redux';

// loolu
import productReducer from './slices/product';
import snackbarReducer from './slices/snackbar';
import usersReducer from './slices/users';
import menuReducer from './slices/menu';
import authReducer from './slices/auth';
import catalogueReducer from './slices/catalog';
import healthContentReducer from './slices/healthContent';
import reportsReducer from './slices/reports';
import chatGptReducer from './slices/chatgpt';
import aiConfigurationsReducer from './slices/aiConfig';
import releasesReducer from './slices/releases';
import vademecumReducer from './slices/vademecum';
import contentProviders from './slices/contentProviders';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    product: productReducer,
    healthContent: healthContentReducer,
    menu: menuReducer,
    users: usersReducer,
    auth: authReducer,
    snackbar: snackbarReducer,
    catalogue: catalogueReducer,
    reports: reportsReducer,
    chatGpt: chatGptReducer,
    aiConfigs: aiConfigurationsReducer,
    releases: releasesReducer,
    vademecum: vademecumReducer,
    contentProviders: contentProviders
});

export default reducer;
